(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-before-after"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initItem(el) {
    var dir = el.dataset.direction || 'horizontal';
    var pos = parseFloat(el.dataset.pos) || 50;
    var before = el.querySelector('.cba-before');
    var after = el.querySelector('.cba-after');
    var line = el.querySelector('.cba-handle-line');
    var circle = el.querySelector('.cba-handle-circle');
    var dragging = false;

    function setPos(p) {
      p = Math.max(2, Math.min(98, p));
      if (dir === 'horizontal') {
        before.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
        after.style.clipPath = 'inset(0 0 0 ' + p + '%)';
        line.style.left = p + '%';
        circle.style.left = p + '%';
        circle.style.top = '50%';
      } else {
        before.style.clipPath = 'inset(0 0 ' + (100 - p) + '% 0)';
        after.style.clipPath = 'inset(' + p + '% 0 0 0)';
        line.style.top = p + '%';
        circle.style.top = p + '%';
        circle.style.left = '50%';
      }
    }

    function getPos(e) {
      var rect = el.getBoundingClientRect();
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      var clientY = e.touches ? e.touches[0].clientY : e.clientY;
      if (dir === 'horizontal') {
        return ((clientX - rect.left) / rect.width) * 100;
      } else {
        return ((clientY - rect.top) / rect.height) * 100;
      }
    }

    setPos(pos);

    el.addEventListener('mousedown', function(e) { dragging = true; e.preventDefault(); });
    el.addEventListener('touchstart', function(e) { dragging = true; }, { passive: true });

    window.addEventListener('mousemove', function(e) {
      if (!dragging) return;
      setPos(getPos(e));
    });
    window.addEventListener('touchmove', function(e) {
      if (!dragging) return;
      setPos(getPos(e));
    }, { passive: true });

    window.addEventListener('mouseup', function() { dragging = false; });
    window.addEventListener('touchend', function() { dragging = false; });
  }

  // NUEVO: La función ahora recibe el contenedor correcto
  function initLoadMore(wrapper) {
    var btn = wrapper.querySelector('.cba-load-more-btn');
    if (!btn) return;

    // Resetea el botón para evitar doble carga de eventos en el editor de Shopify
    var newBtn = btn.cloneNode(true);
    btn.parentNode.replaceChild(newBtn, btn);
    btn = newBtn;

    btn.addEventListener('click', function() {
      var step = parseInt(this.dataset.step) || 2;
      var hiddenItems = wrapper.querySelectorAll('.cba-block-wrapper.cba-hidden-desktop');
      
      for (var i = 0; i < step; i++) {
        if (hiddenItems[i]) {
          hiddenItems[i].classList.remove('cba-hidden-desktop');
        }
      }

      if (wrapper.querySelectorAll('.cba-block-wrapper.cba-hidden-desktop').length === 0) {
        var container = wrapper.querySelector('.cba-load-more-container');
        if (container) container.style.display = 'none';
      }
    });
  }

  function init() {
    document.querySelectorAll('.cba-item').forEach(function(el) {
      if (!el.dataset.cbaInit) {
        el.dataset.cbaInit = '1';
        initItem(el);
      }
    });

    // NUEVO: Busca específicamente la clase general que agregamos
    document.querySelectorAll('.custom-before-after-wrapper').forEach(function(wrapper) {
      initLoadMore(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-horizontal-ticker"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initTicker(id) {
      var el = document.getElementById('cht-' + id);
      if (!el) return;

      var tracks = el.querySelectorAll('.cht-track');
      var duration = el.dataset.duration || '20';
      var direction = el.dataset.direction || 'left';
      var pauseOnHover = el.dataset.pause === 'true';

      tracks.forEach(function(track) {
        track.style.setProperty('--cht-duration', duration + 's');
        if (direction === 'right') {
          track.style.animationDirection = 'reverse';
        }
      });

      if (pauseOnHover) {
        var wrapper = el.querySelector('.cht-track-wrapper');
        wrapper.addEventListener('mouseenter', function() {
          tracks.forEach(function(t) { t.style.animationPlayState = 'paused'; });
        });
        wrapper.addEventListener('mouseleave', function() {
          tracks.forEach(function(t) { t.style.animationPlayState = 'running'; });
        });
      }
    }

    document.querySelectorAll('[id^="cht-"]').forEach(function(el) {
      initTicker(el.id.replace('cht-', ''));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-scrolling-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initBanner(sectionId) {
      var el = document.getElementById('custom-scrolling-banner-' + sectionId);
      if (!el) return;

      var tracks = el.querySelectorAll('.csb-track');
      var duration = el.dataset.duration || '20';
      var direction = el.dataset.direction || 'left';
      var pauseOnHover = el.dataset.pause === 'true';

      tracks.forEach(function(track) {
        track.style.setProperty('--csb-duration', duration + 's');
        if (direction === 'right') {
          track.style.animationDirection = 'reverse';
        }
      });

      if (pauseOnHover) {
        var wrapper = el.querySelector('.csb-track-wrapper');
        wrapper.style.setProperty('--csb-pause', 'running');
        wrapper.addEventListener('mouseenter', function() {
          this.style.setProperty('--csb-pause', 'paused');
        });
        wrapper.addEventListener('mouseleave', function() {
          this.style.setProperty('--csb-pause', 'running');
        });
      }
    }

    document.querySelectorAll('[id^="custom-scrolling-banner-"]').forEach(function(el) {
      initBanner(el.id.replace('custom-scrolling-banner-', ''));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.stickyType    = this.dataset.stickyType;
    this.isAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
    this.isTransparent  = this.dataset.transparent === 'true';
    this.isRounded      = this.dataset.headerRounded === 'true';
    this.containerSize  = this.dataset.containerSize;

    this.header = document.querySelector('.section-header');
    this.currentScrollTop = 0;
    this.preventReveal    = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.isAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    // Transparent: start transparent if at top
    if (this.isTransparent && window.pageYOffset <= 0) {
      this.classList.add('header-wrapper--transparent');
    }

    this.headerBounds = { top: 0, bottom: this.header.offsetHeight };
    this.createObserver();

    this.onScrollHandler   = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    requestAnimationFrame(() => { this.onScroll(); });
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    const observer = new IntersectionObserver((entries, obs) => {
      this.headerBounds = entries[0].intersectionRect;
      obs.disconnect();
    });
    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      // Scrolling DOWN past header
      this.header.classList.add('scrolled-past-header');

      if (!this.preventHide) {
        requestAnimationFrame(this.hide.bind(this));
      }

      // Remove transparent when scrolled
      if (this.isTransparent) {
        this.classList.remove('header-wrapper--transparent');
      }

      if (this.isRounded) {
        this.classList.add('header-rounded', this.containerSize);
        this.classList.remove('header-rounded-ease-out');
      }

    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      // Scrolling UP (still past header)
      this.header.classList.add('scrolled-past-header');

      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }

    } else if (scrollTop <= this.headerBounds.top) {
      // Back at TOP
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));

      if (this.isTransparent) {
        this.classList.add('header-wrapper--transparent');
      }

      if (this.isRounded) {
        this.classList.remove('header-rounded', this.containerSize);
        this.classList.add('header-rounded-ease-out');
      }
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.isAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.isAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.isAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(d => d.close && d.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    if (this.searchModal) this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
